<template>
  <div>
    <zj-layout-container
      v-loading="loading"
      element-loading-text="加载中..."
    >
      <zj-layout-header>
        <div class="listtitle">照明设备</div>
        <el-form
          class="zj-search-form"
          ref="queryForm"
          :model="queryParams"
          :label-width="labelWidth"
        >
          <el-form-item label="设备名称" prop="equipmentName">
            <el-input
              v-model="queryParams.equipmentName"
              placeholder="请输入设备名称"
            ></el-input>
          </el-form-item>

          <el-form-item label="区域" prop="areaCode">
            <treeselect
              v-model="queryParams.areaCode"
              :options="regionData"
              placeholder="请选择区域"
            />
          </el-form-item>

          <el-form-item label="设备编号" prop="equipmentNo">
            <el-input
              v-model="queryParams.equipmentNo"
              placeholder="请输入设备编号"
            ></el-input>
          </el-form-item>

          <el-form-item label="IP地址" prop="equipmentIp">
            <el-input
              v-model="queryParams.equipmentIp"
              placeholder="请输入IP地址"
            ></el-input>
          </el-form-item>
          
          <el-form-item label class="right">
            <el-button @click="onSearch">查 询</el-button>
            <el-button @click="onCancel">清 理</el-button>
            <el-button @click="onAdd">新 增</el-button>
          </el-form-item>
        </el-form>
        <el-divider></el-divider>
      </zj-layout-header>
      <zj-layout-main>
        <div class="zj-layout-main-content bgcolor scrollable">
          <div class="zj-table-container">
            <el-table :data="lightEquipmentList" border style="width: 100%" fixed>
              <el-table-column type="index" label="序号" width="80" align="center"></el-table-column>
              <el-table-column prop="equipmentName" label="设备名称"></el-table-column>
              <el-table-column prop="equipmentNo" label="设备编号"></el-table-column>
              <el-table-column prop="equipmentIp" label="IP地址"></el-table-column>
              <el-table-column prop="areaCodeTranslated" label="区域"></el-table-column>
              <el-table-column prop="longitude" label="经度"></el-table-column>
              <el-table-column prop="latitude" label="纬度"></el-table-column>
              <el-table-column prop="onlineStatus" label="设备状态" width="140">
                <template slot-scope="scope">
                  <span v-if="scope.row.onlineStatus == 1" style="color: green">在线</span>
                  <span v-if="scope.row.onlineStatus == 2" style="color: red">离线</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="120" align="center">
                <template slot-scope="scope">
                  <template>
                    <el-button
                      @click="queryDetail(scope.row)"
                      type="text"
                      size="small"
                      >查看</el-button
                    >
                    <el-button
                      @click="editDetail(scope.row)"
                      type="text"
                      size="small"
                      >编辑</el-button
                    >
                    <el-button
                      @click="deleteClick(scope.row)"
                      type="text"
                      size="small"
                      >删除</el-button
                    >
                  </template>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </zj-layout-main>
      <zj-layout-footer>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryParams.pageNum"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="queryParams.pageSize"  
          layout="total, sizes, prev, pager, next, jumper"
          background
          :total="total"
        ></el-pagination>
      </zj-layout-footer>
    </zj-layout-container>
  </div>
</template>

<script>
import { getEquipmentCode, listEquipment, delEquipment } from "@/api/src/equipment";
import { listEquipmentAreaTree } from "@/api/src/equipmentArea";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
export default {
  name: "LightEquipmentView",
  controller: "UI",
  action: "LightEquipmentView",
  components: {
    Treeselect
  },
  data() {
    return {
      // 设备类型code
      code: '',
      // 遮罩层
      loading: false,
      // 总条数
      total: 0,
      // 查询参数
      queryParams: {
          equipmentName: null,
          areaCode: null,
          equipmentNo: null,
          equipmentIp: null,
          pageNum: 1,
          pageSize: 10
      },
      // 区域数据
      regionData: [],
      // 表格数据
      lightEquipmentList: [],
    };
  },
  created: function() {
    this.$nextTick(()=>{
      this.init();
      this.getAreaTree();
    });
  },
  methods: {
    // 查询区域树
    getAreaTree(){
      listEquipmentAreaTree().then(response =>{
        // 修改tree字段
        const mapTree = obj => {
          const haveChildren = Array.isArray(obj.children) && obj.children.length > 0;
          return{
            id: obj.code,
            label: obj.label,
            children: haveChildren ? obj.children.map(i => mapTree(i)) : undefined
          }
        }
        this.regionData = response.data.map(obj => mapTree(obj));
      });
    },
    // 获取设备code
    init(){
      getEquipmentCode('lightEquipment').then(response =>{
        this.code = response.data;
        this.getList();
      });
    },
    // 查询
    getList() {
      this.loading = true;
      this.queryParams.categoryCode = this.code;
      listEquipment(this.queryParams).then(response =>{
        this.lightEquipmentList = response.rows;
        this.total = response.total;
        this.loading = false;
      });
    },
    // 点击查询按钮
    onSearch() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
    // 点击清理按钮
    onCancel() {
      this.resetForm("queryForm");
      this.onSearch();
    },
    // 点击新增按钮
    onAdd() {
      this.$router.push({
        path: "/plugin/equipment/UI/LightEquipmentInfo",
        query: { areaTree: this.regionData, categoryCode: this.code, type: "add"},
      });
    },
    // 行查看
    queryDetail(row) {
      this.$router.push({
        path: "/plugin/equipment/ui/LightEquipmentInfo",
        query: { areaTree: this.regionData, categoryCode: this.code, id: row.id, type: "query" },
      });
    },
    // 行编辑
    editDetail(row) {
      this.$router.push({
        path: "/plugin/equipment/ui/LightEquipmentInfo",
        query: { areaTree: this.regionData, categoryCode: this.code, id: row.id, type: "edit" },
      });
    },
    // 行删除
    deleteClick(row) {
      this.$confirm("此操作将永久删除该行数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(function() {
        return delEquipment({id:row.id});
      }).then(() => {
        this.$message({type: "success", message: "删除成功!"});
        this.getList();
      }).catch(() => {});
    },
    // 点击每页显示的条数
    handleSizeChange(val){
      this.queryParams.pageSize = val;
      this.getList();
    },
    // 点击切换到某页
    handleCurrentChange(val){
      this.queryParams.pageNum = val;
      this.getList();
    }
  },
};
</script>
<style scoped>
::v-deep .el-form-item{
  vertical-align: middle;
}
::v-deep .vue-treeselect__control{
  width: 178px;
  height: 4rem;
  border-radius: 0px !important;
}
::v-deep .vue-treeselect__placeholder, 
::v-deep .vue-treeselect__single-value{
  line-height: unset;
}
</style>
